import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { isDevMode, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy, isPlatform } from '@ionic/angular';
import { IonicConfig } from '@ionic/core';
import { CoreModule, MaterialModule } from '@libs/order-process/shared/core';
import { SharedUiModule } from '@libs/shared/ui';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule, TranslateModuleConfig } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

registerLocaleData(localeDe);

const getConfig = (): IonicConfig => {
  let config: IonicConfig = {
    backButtonText: '',
    spinner: 'crescent',
    mode: 'ios',
    backButtonIcon: 'arrow-back-outline',
    animated: false,
  };

  if (isPlatform('android')) {
    config = {
      ...config,
      swipeBackEnabled: false,
      navAnimation: undefined,
    };
  }

  return config;
};

const translateModuleConfig: TranslateModuleConfig = {
  loader: provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    MaterialModule,
    SharedUiModule,
    IonicModule.forRoot(getConfig()),
    TranslateModule.forRoot(translateModuleConfig),
    StoreModule.forRoot(),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    DatePipe,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
